import cx from 'classnames';
import { useAnalytics } from 'libs/utils/site/analytics';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { OverflowFilters } from 'pages/custom/shared/overflow/OverflowFilters';
import { TechportButtons } from 'pages/custom/Technoport/TechportButtons';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext } from 'react';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const TECHPORT_BUILDING = {
    name: 'Techport - main',
    floors: [
        { name: '1 Etasje', setId: '0b78fdaf-0192-4353-a30a-597a4046f5fb' },
        { name: '1 Etasje', setId: 'f67dfcf4-b838-4567-abb9-d66f8cc23fc1' },
        { name: '3 Etasje', setId: '43bf8a19-553a-4eff-b0cd-ea7c1e647080' }
    ]
};

export const TechportPage = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);
    const analytics = useAnalytics();

    const [floor1, floor2, floor3] = TECHPORT_BUILDING.floors;

    function isSetHighlighted(mapSetId: string) {
        return ctxView.visibleMapSetIds.includes(mapSetId);
    }

    function setVisibleMapSetAndHideOthers(mapSetId: string) {
        const visible = ctxView.visibleMapSetIds;
        const newVisible = visible.filter(
            (id) => id !== floor1.setId && id !== floor2.setId && id !== floor3.setId
        );
        newVisible.push(mapSetId);
        ctxView.setVisibleMapSetIds(newVisible);

        analytics.track('floor_button.clicked', {
            building: 'techport',
            source: 'custom_buttons',
            floorId: mapSetId
        });
    }

    return (
        <S_TechportPage className={cx(props.className, 'cleanmap')}>
            <CustomMapPage
                mapId={'1cc1af53-8d8d-43ec-b4f1-f5039b306a47'}
                header={{
                    logo: 'https://uploads-ssl.webflow.com/62975d9a594b2be9d7f4950c/62b2ef8f20ee15cdc3a16bad_logo-symbol.png',
                    logoText: 'Trondheim Tech Port',
                    logoSubtext: 'Konferansen 2023 - Bridging the Gap',
                    link: 'https://www.trondheimtechport.no/',
                    linkText: Localization.WEBSITE
                }}
                controls={<TechportButtons />}
                inlineFooterButtons={true}
                hideFloors
                topOverflow={
                    <OverflowFilters
                        highlightedBackground="linear-gradient(90deg, #4988AC 0%, #266384 100%)"
                        items={[
                            {
                                iconName: 'layer-group',
                                text: '1. Etasje',
                                onClick: () => {
                                    setVisibleMapSetAndHideOthers(floor1.setId);
                                },
                                highlighted: isSetHighlighted(floor1.setId)
                            },
                            {
                                iconName: 'layer-group',
                                text: '2. Etasje',
                                onClick: () => {
                                    setVisibleMapSetAndHideOthers(floor2.setId);
                                },
                                highlighted: isSetHighlighted(floor2.setId)
                            },
                            {
                                iconName: 'layer-group',
                                text: '3. Etasje',
                                onClick: () => {
                                    setVisibleMapSetAndHideOthers(floor3.setId);
                                },
                                highlighted: isSetHighlighted(floor3.setId)
                            }
                        ]}
                    />
                }
            />
        </S_TechportPage>
    );
};

const S_TechportPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
